import { serializeSuperjson } from '@lib/superjson';
import {
  UpdateAndAssignSnapQuoteRequest,
  type UpdateAndAssignSnapQuoteRequestParams,
  UpdateAndAssignSnapQuoteResponse,
} from '@snap-types/actions/update-and-assign-snap-quote';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

const [updateAndAssignSnapQuote, _] = injectMutation<
  {
    params: UpdateAndAssignSnapQuoteRequestParams;
    body: UpdateAndAssignSnapQuoteRequest;
  },
  UpdateAndAssignSnapQuoteResponse
>(
  `${QUOTE_BUILDER_SLICE_NAME}/updateAndAssignSnapQuote`,
  ({ params, body }) => ({
    url: buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteUuid,
      'update-and-assign',
    ),
    method: 'POST',
    body: serializeSuperjson(body),
  }),
);

export { updateAndAssignSnapQuote };
